import './PanoramicView.css';

const PanoramicView = () => {
  return (
    <section className="panoramic-view" id="vision-in-motion">
      <h2 className="panoramic-heading" style={{ color: 'rgba(0,0,0,0.7)' }}>THE VISION IN MOTION</h2>
      <div className="panoramic-container">
        <iframe
          className="panoramic-video"
          src="https://www.youtube.com/embed/HSCMbLIaxlI?autoplay=1&mute=1&loop=1&playlist=HSCMbLIaxlI&controls=0&showinfo=0&modestbranding=1&rel=0&iv_load_policy=3&disablekb=1&fs=0"
          title="The Vision in Motion"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        ></iframe>
      </div>
      <p className="panoramic-description">
        IMMERSE YOURSELF IN THE COMMUNITY — A 360° JOURNEY THROUGH DESIGN, SPACE, AND SERENITY
      </p>
    </section>
  );
};

export default PanoramicView;
